var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableSortArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00004 0L9.94979 4.94975H0.050293L5.00004 0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableSortArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TableSortArrow.df5bb4e89e3074e7d03c5429756c7c68.svg";